export enum AccountType {
  Single = 0,
  Joint = 1
}
